import * as React from "react";
import { Stack, Strong, Text } from "@origin-digital/ods-core";
import dayjs from "dayjs";

const DATE_FORMAT = "DD/MM/YY";
const TIME_FORMAT = "hh:mma";

interface RequestorInfoProps {
  requesterName: string;
  submittedDateTime: Date | string;
  behaviourType?: "lodged" | "submitted";
  actionType?: string;
  closeByName?: string;
  closeBehaviourType?: "marked";
  closeActionType?: string;
  closeDateTime?: Date | string;
  cancelByName?: string;
  cancelDateTime?: Date | string;
  cancelActionType?: string;
}

const RequestorInfoInternet: React.FC<RequestorInfoProps> = ({
  requesterName,
  submittedDateTime,
  behaviourType = "lodged",
  actionType,
  closeByName,
  closeBehaviourType = "marked",
  closeActionType,
  closeDateTime,
  cancelByName,
  cancelDateTime,
  cancelActionType,
}) => {
  const dateTime =
    submittedDateTime instanceof Date
      ? submittedDateTime
      : new Date(submittedDateTime);
  const closeDate =
    closeDateTime instanceof Date
      ? closeDateTime
      : new Date(closeDateTime || "");
  const cancelDate =
    cancelDateTime instanceof Date
      ? cancelDateTime
      : new Date(cancelDateTime || "");
  return (
    <Stack space="xsmall">
      <Text>
        <Strong>{requesterName}</Strong> {behaviourType}{" "}
        {actionType ? `${actionType} ` : ""}on{" "}
        {dayjs(dateTime).format(DATE_FORMAT)} at{" "}
        {dayjs(dateTime).format(TIME_FORMAT)}.
      </Text>
      {closeDateTime && (
        <Text>
          <Strong>{closeByName}</Strong> {closeBehaviourType}{" "}
          {closeActionType ? `${closeActionType} ` : ""}on{" "}
          {dayjs(closeDate).format(DATE_FORMAT)} at{" "}
          {dayjs(closeDate).format(TIME_FORMAT)}.
        </Text>
      )}
      {cancelDateTime && (
        <Text>
          <Strong>{cancelByName}</Strong> marked{" "}
          {cancelActionType ? `${cancelActionType} ` : ""}on{" "}
          {dayjs(cancelDate).format(DATE_FORMAT)} at{" "}
          {dayjs(cancelDate).format(TIME_FORMAT)}.
        </Text>
      )}
    </Stack>
  );
};

export default RequestorInfoInternet;
